<template>
	<div class="step step1">
		<step-header :current="1"></step-header>
		<el-form ref="form" :model="form" :rules="rules" label-width="100px">
			<el-form-item prop="name" label="承办机构">
				<el-select v-model="form.value" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="pwd" label="考次">
				<el-select v-model="form.value" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="pwd" label="科目">
				<el-select v-model="form.value" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="pwd" label="级别">
				<el-select v-model="form.value" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="pwd" label="免冠照片">
				<el-select v-model="form.value" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<div style="text-align:center">
				<el-button type="primary" size="mini" @click="submit">下一步</el-button>
			</div>
		</el-form>
	</div>
</template>
<script>
import stepHeader from "./stepHeader";

export default {
	data() {
		return {
			form: {},
			options: [
				{
					value: "选项1",
					label: "黄金糕"
				},
				{
					value: "选项2",
					label: "双皮奶"
				},
				{
					value: "选项3",
					label: "蚵仔煎"
				},
				{
					value: "选项4",
					label: "龙须面"
				},
				{
					value: "选项5",
					label: "北京烤鸭"
				}
			],
			rules: {}
		};
	},
	methods: {
		submit() {
			this.$emit("submit", this.form);
		}
	},
	components: {
		stepHeader
	}
};
</script>
